module.exports = __webpack_public_path__ + "static/media/help-click-to-fill.7c4217fe.png";